import axios from '../base/axios';
import API_KEY from './key';

const GET_TVLATEST = 'flixfrenzy/redux/GET_TVLATEST';

// eslint-disable-next-line default-param-last
const tvLatestReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVLATEST:
      return action.payload;
    default:
      return state;
  }
};

export const getTvLatest = () => (dispatch) => {
  axios.get(`tv/latest?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVLATEST,
      payload: res.data,
    });
  });
};

export default tvLatestReducer;
